import { includes, values } from 'ramda';

export type NATIONAL = 'national';
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NATIONAL = 'national' as NATIONAL;

export type INTERNATIONAL = 'international';
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const INTERNATIONAL = 'international' as INTERNATIONAL;

export enum REGION_REGIONAL {
  AUVERGNE = 'auvergne_rhone_alpes',
  BOURGOGNE = 'bourgogne_franche_comte',
  BRETAGNE = 'bretagne',
  CENTRE = 'centre_val_de_loire',
  CORSE = 'corse',
  DOM = 'dom',
  GRAND_EST = 'grand_est',
  HAUTS_DE_FRANCE = 'hauts_de_france',
  ILE_DE_FRANCE = 'ile_de_france',
  NORMANDIE = 'normandie',
  NOUVELLE_AQUITAINE = 'nouvelle_aquitaine',
  OCCITANIE = 'occitanie',
  PACA = 'paca',
  PAYS_DE_LA_LOIRE = 'pays_de_la_loire',
}

export type REGION_NATIONAL = REGION_REGIONAL | NATIONAL;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const REGION_NATIONAL = {
  NATIONAL,
  ...REGION_REGIONAL,
};

export enum REGION_INTERNATIONAL {
  AFRIQUE = 'afrique',
  AMERIQUE = 'ameriques',
  ASIE = 'asie',
  EUROPE = 'europe',
  OCEANIE = 'oceanie',
}

export type REGION = REGION_NATIONAL | REGION_INTERNATIONAL | INTERNATIONAL;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const REGION = {
  ...REGION_NATIONAL,
  ...REGION_INTERNATIONAL,
  INTERNATIONAL,
};

export const isRegionalRegion = (value: string | REGION): boolean =>
  includes(value, values(REGION_REGIONAL));

export const isNationalRegion = (value: string | REGION): boolean =>
  includes(value, values(REGION_NATIONAL));

export const isInternationalRegion = (value: string | REGION): boolean =>
  includes(value, values(REGION_INTERNATIONAL));
